export default {
    getSearchFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getEuPontokRowActions: state => state.eupontokRowActions,
    getEupontokHeaderFields: state => state.eupontokHeaderFields,
    getBnoHeaderFields: state => state.bnoKodHeaderFields,
    getEuJogHeaderFields: state => state.eujogHeaderFields
}
